<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="d-flex flex-column w-100 my-3">
    <div class="row items-center">
      <div
        :class="question.image ? 'col-9' : 'col-12'"
        class="col-9 text-primary text-500"
        v-html="question.statement"
      >
        {{ question.statement }}
      </div>
      <EntityImgContainer
        v-if="question.image"
        class="col-3 pe-0"
        :alt="question.statement"
        :img-url="question.image"
      />
    </div>
    <QuestionAnswer
      :key="`answer-${question.question_number}`"
      :input-for="`answer-${question.question_number}`"
      :question="question"
      :input-reference="`answer-${question.question_number}`"
    />
  </div>
</template>
<script>
import EntityImgContainer from '../EntityImgContainer.vue'
import QuestionAnswer from './QuestionAnswer.vue'
export default {
  components: { QuestionAnswer, EntityImgContainer },
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
}
</script>
<style scoped>
b {
  font-weight: 600;
}
i,
em {
  font-style: italic;
}
li {
  font-weight: 500;
}
b li {
  font-weight: 600;
}
</style>
